<template lang="pug">
  v-container.pr-sm-0.fill-height.align-center.flex-column.justify-center(fluid)
    v-card(flat width="800px" class="rounded-card mx-auto" d-flex justify-center)
      TagDetailDialog(
          v-if="showTagDetailDialog"
          :show="showTagDetailDialog"
          :tagDetail="tagDetail"
          @saved="onUpdateTag"
          @create="onCreateNewTag"
          @close="onCloseTagDetailDialog"
          @delete="onDeleteTag")
      v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
        template( v-slot:action="{attrs}")
          v-btn(text v-bind="attrs"
            @click="snackBar = false") {{ $t('buttons.closeButtonLabel') }}
      v-toolbar.elevation-0(v-if="$vuetify.breakpoint.mdAndUp")
        v-btn(@click="onShowTagDetailDialogClick" color="primary")
          v-icon.pr-4 fas fa-plus
          span {{$t('settingsPage.addNewLabel')}}
      v-row.ma-0.my-0
        v-col.px-0.py-0(cols="12")
          v-list.px-sm-0
            v-list-item.px-sm-0(v-if="tagList" v-for="(item,idx) in tagList" :key="idx")
              v-list-item-icon
                v-icon.pa-0 {{getIcon(item.iconClass)}}
              v-list-item-content(@click="onTagClick(item)") {{item.title}}
      v-fab-transition(v-if="$vuetify.breakpoint.smAndDown")
        v-btn.addMobileButton(@click="onShowTagDetailDialogClick" color="pink" medium dark right absolute
          fab
          bottom
          )
          v-icon fas fa-plus
      v-skeleton-loader(v-if="fetchInProgress"
        type="list-item@12"
        width="100%")



</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from "vue-property-decorator";
import {Action} from "vuex-class";
import {FETCH_TAG_BY_ID, FETCH_TAGS} from "@/store/action-types";
import TagDetailDialog from "@/components/settings/TagDetailDialog.vue";
import Tag from "@/model/tennant/Tag";

@Component({
  components: {
    TagDetailDialog
  }
})

export default class TagPage extends Vue {

  @Action(FETCH_TAGS) fetchTagList!: ({ (): Promise<Tag[]> })
  @Action(FETCH_TAG_BY_ID) fetchTagDetail!: ({ (payload: number): Promise<Tag> })

  private tagList: Tag[] | undefined = []
  private showTagDetailDialog: boolean = false
  private tagDetail: Tag | null = null
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private fetchInProgress: boolean = false

  getIcon (item: string):string | null {
    if(item) {
      return item  ? `fas ${item}` : null
    } else {
      return ''
    }
  }

  onShowTagDetailDialogClick () {
    this.tagDetail = null
      this.showTagDetailDialog = true
  }

  onUpdateTag () {
    this.showTagDetailDialog = false
    this.snackBar = true
    this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
    this.snackBarColor = 'success'
    this.fetchData()
  }

  onCreateNewTag () {
    this.showTagDetailDialog = false
    this.snackBar = true
    this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
    this.snackBarColor = 'success'
    this.fetchData()
  }

  onCloseTagDetailDialog () {
    this.showTagDetailDialog = false
  }

  onDeleteTag () {
    this.showTagDetailDialog = false
    this.snackBar = true
    this.snackBarMessage = this.$t('settingsPage.deleted').toString()
    this.snackBarColor = 'success'
    this.fetchData()
  }

  onTagClick (item:Tag): void{
    this.tagDetail = item
     this.showTagDetailDialog = true
  }

  async fetchData ():Promise<void> {
    try {
      this.fetchInProgress = true
      this.tagList = await this.fetchTagList()
    }catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorMessage').toString()
      this.snackBarColor = 'error'
    }finally {
      this.fetchInProgress = false
    }
  }

  mounted () {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
.addMobileButton {
  margin-bottom: 160px;
  bottom: 160px;
  margin-right: 16px
  position: fixed
}

.v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0 0 16px 16px;
}
</style>
